'use client';

import classnames from 'classnames';

import { Pagination } from './Pagination';
import type { PaginationProps } from './Pagination.types';

import styles from './OffsetPagination.module.scss';

/**
 * `Pagination` that takes itself off the page when there is only one page of
 * results to show.
 */
function OffsetPagination({
  className,
  totalRecords,
  pageSize,
  testId = 'ui-offset-pagination',
  ...rest
}: PaginationProps) {
  if (totalRecords <= pageSize) {
    return null;
  }

  return (
    <Pagination
      testId={testId}
      className={classnames(styles['main'], className)}
      totalRecords={totalRecords}
      pageSize={pageSize}
      {...rest}
    />
  );
}

export { OffsetPagination };
